module.exports = __webpack_public_path__ + "static/media/AppStore.73ef767d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/AppStore.svg
// module id = 92
// module chunks = 0